import { type IOrganizationForm } from '@/components/Organization';

import { useBeneficiaryContext, useSaveBeneficiary } from '../model';

import InlineOrganizationForm from './InlineOrganizationForm';

const EditBeneficiaryForm = () => {
  const { beneficiary, setMode } = useBeneficiaryContext();
  const saveBeneficiary = useSaveBeneficiary();

  const cancelEditing = () => setMode('view');

  const organizationDetails: IOrganizationForm = {
    street: beneficiary?.street || '',
    city: beneficiary?.city || '',
    postalCode: beneficiary?.postalCode || '',
    region: beneficiary?.region || '',
    country: beneficiary?.country || '',
    companyName: beneficiary?.companyName || '',
    companyWebsite: beneficiary?.companyWebsite || '',
    companyRegistration: beneficiary?.companyRegistrationNumber || '',
    streetNumber: beneficiary?.streetNumber || '',
  };

  return (
    <InlineOrganizationForm defaultValues={organizationDetails} onSave={saveBeneficiary} onCancel={cancelEditing} />
  );
};

export default EditBeneficiaryForm;
